import { FormBuilder } from "components/form/FormBuilder";
import React from "react";

import { i18nService } from "services";
import { ActiveToolboxFacetType, IToolboxFacet } from "types";

import { makeSchema } from "./formSchema";

interface ToolboxQuickSearchFormProps {
  facets: IToolboxFacet[];
  onSubmit: (data: ActiveToolboxFacetType) => void;
  isLoading?: boolean;
}

export const ToolboxQuickSearchForm: React.FC<ToolboxQuickSearchFormProps> = ({
  facets,
  onSubmit,
  isLoading,
}) => {
  return (
    <div className="toolbox-quick-search-form">
      <FormBuilder
        {...makeSchema(facets)}
        submitLabel={i18nService.copy["toolboxQuickSearch.showTools"]}
        onFormSubmit={onSubmit}
        isSubmitting={isLoading}
        autoComplete="off"
      />
    </div>
  );
};
